import React from "react";

import { defineMessages, useIntl } from "react-intl";

import {
  Company,
  Deal,
  EntityTypeSupportingPostCreationModal,
  Person,
} from "@mapmycustomers/shared/types/entity";

import GroupsModal from "@app/component/actions/components/GroupsModal";

interface Props {
  entity: Company | Deal | Person;
  entityType?: EntityTypeSupportingPostCreationModal;
  onHide: (updated?: boolean) => void;
  onUpdate?: () => void;
}

const messages = defineMessages({
  manageGroups: {
    id: "postCreateModal.addToGroupModal.title",
    defaultMessage: "Add to groups",
    description: "Label of the Manage Groups action",
  },
});

const Groups = ({ entity, entityType, onHide, onUpdate }: Props) => {
  const intl = useIntl();

  return (
    <GroupsModal
      entity={entity}
      entityType={entityType!}
      onHide={onHide}
      onReload={onUpdate}
      title={intl.formatMessage(messages.manageGroups)}
    />
  );
};

export default Groups;
